import $ from 'jquery';
import cuid from 'cuid';

class Recaptcha {
    constructor() {
        this.options = {
            callback: Recaptcha._generateCallbackName()
        };
        this.ready = new Promise(resolve => {
            window[this.options.callback] = () => resolve(grecaptcha);
        });

        this._appendScript();
    }

    _appendScript() {
        let script = document.createElement('script');
        script.src = 'https://www.google.com/recaptcha/api.js?' + $.param({
            render: 'explicit',
            onload: this.options.callback,
        });
        document.addEventListener('DOMContentLoaded', () => {
            document.body.appendChild(script);
        });
    }

    static _generateCallbackName() {
        return `recaptcha_cb_${cuid()}`;
    }
}

export default new Recaptcha();
